import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from 'libs/shared/src/services/config/default.config';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the change password component form.
 * Defines the fields to display for the form.
 */
export const CHANGE_PASSWORD_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttonText',
      label: 'components.changePassword.schema.buttonText',
      type: 'text',
      inputType: 'text',
      default: '',
      groupingName: 'components.changePassword.schema.button'
    },
    {
      formControlName: 'buttons',
      label: 'components.changePassword.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
